import EcoBundle1 from 'eco-design/sections/eco-bundle-1';
import { EcoBundle1ItemProps } from 'eco-design/sections/eco-bundle-1/eco-bundle-1-item';
import styles from './index.module.scss';
export default function Comp() {
    const items: EcoBundle1ItemProps[] = [
        {
            imgTitle: 'bundle kit',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
            title: `EcoFlow DELTA 3 Plus Portable Power Station`,
            subTitle: '1024Wh Capacity | 1800W Output ',
            descItems: [`1500W AC Input & 10 ms UPS`, `0-100% in 56 min`],

            lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
            lChildren: 'Button Text',
            lType: 'filled',
            lTheme: 'blue',
            lRadius: 'ellipse',

            cHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
            cChildren: 'Button Text',
            cType: 'text',
            cTheme: 'blue',
            cRadius: 'ellipse',
            cIsWithRightArrow: true,

            rHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
            rChildren: 'Button Text',
            rType: 'text',
            rTheme: 'blue',
            rIsWithRightArrow: true,

            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                    title: 'EcoFlow DELTA 3 Battery(1kWh)',
                    price: 99.9,
                    priceCompareAt: 199.9,
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                    title: 'EcoFlow DELTA 3 Battery(1kWh)',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                    title: 'EcoFlow DELTA 3 Battery(1kWh)',
                },
            ],
        },
        {
            imgTitle: 'bundle kit',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
            title: `EcoFlow DELTA 3 Plus Portable Power Station`,
            subTitle: '1024Wh Capacity | 1800W Output ',
            descItems: [`1500W AC Input & 10 ms UPS`, `0-100% in 56 min`],

            lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
            lChildren: 'Button Text',
            lType: 'filled',
            lTheme: 'blue',
            lRadius: 'ellipse',

            cHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
            cChildren: 'Button Text',
            cType: 'text',
            cTheme: 'blue',
            cRadius: 'ellipse',
            cIsWithRightArrow: true,

            rHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
            rChildren: 'Button Text',
            rType: 'text',
            rTheme: 'blue',
            rIsWithRightArrow: true,

            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                    title: 'EcoFlow DELTA 3 Battery(1kWh)',
                    price: 99.9,
                    priceCompareAt: 199.9,
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                    title: 'EcoFlow DELTA 3 Battery(1kWh)',
                },
            ],
        },
        {
            //imgTitle: 'bundle kit',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
            title: `EcoFlow DELTA 3 Plus Portable Power Station`,
            subTitle: '1024Wh Capacity | 1800W Output ',
            descItems: [`1500W AC Input & 10 ms UPS`, `0-100% in 56 min`],

            lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
            lChildren: 'Button Text',
            lType: 'filled',
            lTheme: 'blue',
            lRadius: 'ellipse',

            cHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
            cChildren: 'Button Text',
            cType: 'text',
            cTheme: 'blue',
            cRadius: 'ellipse',
            cIsWithRightArrow: true,

            rHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
            rChildren: 'Button Text',
            rType: 'text',
            rTheme: 'blue',
            rIsWithRightArrow: true,

            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                    title: 'EcoFlow DELTA 3 Battery(1kWh)',
                    price: 99.9,
                    priceCompareAt: 199.9,
                },
            ],
        },
    ];
    return (
        <div className={styles.comp}>
            <EcoBundle1 items={items} />
        </div>
    );
}
